module.exports = __webpack_public_path__ + "img/banner3E.d95769b8.jpg";